import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import keycode from 'keycode';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import axios from 'axios'
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import AddIcon from '@material-ui/icons/Add';
import Paper from '@material-ui/core/Paper';
import {DatePicker} from 'material-ui-pickers';

import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import moment from 'moment';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import CloseIcon from '@material-ui/icons/Close';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import {BASE_URL_APIv5, BASE_HEADER, FILE_HEADER, BASE_URL_API} from "constants/ActionTypes";

const apiUrl = BASE_URL_APIv5+"/company";
const masterTitleLower = "company";
const masterTitleCapital = "Company";

// get token and set config for call the API
const token = localStorage.getItem('apiKey')
const companyIdGlobal = localStorage.getItem('companyId')

//length data for general
const LENGTH_DATA = 20

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

import InputVirtual from 'components/InputVirtual'

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const styles = theme => ({
    appBar: {
        position: 'relative',
    },
      flex: {
        flex: 1,
    },
    button: {
      margin: theme.spacing.unit,
    },
    leftIcon: {
      marginRight: theme.spacing.unit,
    },
    rightIcon: {
      marginLeft: theme.spacing.unit,
    },
    paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
      },
  });

const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
  };
function MySnackbarContent(props) {
    const { classes, className, message, onClose, variant, ...other } = props;
    const Icon = variantIcon[variant];
  
    return (
      <SnackbarContent
        className={classNames(classes[variant], className)}
        aria-describedby="client-snackbar"
        message={
          <span id="client-snackbar" className={classes.message}>
            <Icon className={classNames(classes.iconSnack, classes.iconVariant)} />
            {message}
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            className={classes.close}
            onClick={onClose}
          >
            <CloseIcon className={classes.icon} />
          </IconButton>,
        ]}
        {...other}
      />
    );
  }

const MySnackbarContentWrapper = withStyles(theme => ({
    success: {
      backgroundColor: green[600],
    },
    error: {
      backgroundColor: theme.palette.error.dark,
    },
    info: {
      backgroundColor: theme.palette.primary.dark,
    },
    warning: {
      backgroundColor: amber[700],
    },
    iconSnack: {
      fontSize: 20,
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: theme.spacing.unit,
    },
    message: {
      display: 'flex',
      alignItems: 'center',
    },
  }))(MySnackbarContent);

class DialogForm extends React.Component {

    //handle company dd add
    callbackBusiness = ({id}) => {
        this.setState({businessTypeForm: id})
    };
    // end function ==============================================================================

    async componentDidMount() {
        this.props.showDialog(this.showDialog);
        
    };

    async componentDidUpdate() {
        
        if(this.state.isParentClick == true){
            if(this.props.idData == 0 ){
                this.setState({
                    openDialog: true,
                    action: "tambah",
                    
                    nameForm:"",
                    codeForm: "",
                    businessTypeForm: 0,
                    cityForm: "",
                    countryForm: "",
                    addressForm: "",
                    zipCodeForm: "",
                    stateForm: "",
                    phone1From: "",
                    phone2Form: "",
                    fax1Form: "",
                    fax2Form: "",
                    picNameForm: "",
                    picEmailForm: "",
                    picPhoneForm: "",
                    picMobileForm: "",
                    statusForm: false

                })
            }else{
                this.setState({action: "ubah"});
                this.handleClickOpenEdit(this.props.idData);
            }
            this.setState({ isParentClick : false });
        }
        
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            openDialog: false,
            isParentClick: false,
            action: "tambah",

            //snackbar state
            openSnackSuccess: false,
            openSnackErr: false,
            messageSnackBar:"",

            idData:0,

            //FORM================================================
            nameForm:"",
            codeForm: "",
            businessTypeForm: 0,
            cityForm: "",
            countryForm: "",
            addressForm: "",
            zipCodeForm: "",
            stateForm: "",
            phone1From: "",
            phone2Form: "",
            fax1Form: "",
            fax2Form: "",
            picNameForm: "",
            picEmailForm: "",
            picPhoneForm: "",
            picMobileForm: "",
            statusForm: false
        };

        this.showDialog = this.showDialog.bind(this);
    };

    showDialog() {
        
        this.setState({ isParentClick : true });
    };

    // logic new ================================================================================
    handleClose = async(param) => {
        if(param === 'batal'){
            
            this.setState({ idData:0, openDialog: false });
            this.props.closeDialog(); 
        } else if (param === 'tambah') {
            this.setState({idData:0})
        
            const data = {
                "name" : this.state.nameForm,
                "code" : this.state.codeForm,
                "business_type": this.state.businessTypeForm,
                "city": this.state.cityForm,
                "country": this.state.countryForm,
                "address": this.state.addressForm,
                "zip_code": this.state.zipCodeForm,
                "state": this.state.stateForm,
                "phone1": this.state.phone1From,
                "phone2": this.state.phone2Form,
                "fax1": this.state.fax1Form,
                "fax2": this.state.fax2Form,
                "pic_name": this.state.picNameForm,
                "pic_email": this.state.picEmailForm,
                "pic_phone_no": this.state.picPhoneForm,
                "pic_mobile_no": this.state.picMobileForm,
                "status": this.state.statusForm,
            }

            let obj = JSON.stringify(data);
            
            const result = await axios.post(apiUrl+'/new', obj, BASE_HEADER)
                                .then(res => res)
                                .catch((error) => error.response )
            if(result.data.status == true){
                NotificationManager.success("Success insert "+masterTitleLower+" data", 'Success message') 
                this.setState({ openDialog: false });
                this.props.closeDialog(result.data); 
            }else{
                NotificationManager.error("Failed insert "+masterTitleLower+" data : "+result.data.message, 'Error message')
            }     
        } else if (param === 'ubah') {
            const {idData} = this.state
        
            const data = {
                "name" : this.state.nameForm,
                "code" : this.state.codeForm,
                "business_type": this.state.businessTypeForm,
                "city": this.state.cityForm,
                "country": this.state.countryForm,
                "address": this.state.addressForm,
                "zip_code": this.state.zipCodeForm,
                "state": this.state.stateForm,
                "phone1": this.state.phone1From,
                "phone2": this.state.phone2Form,
                "fax1": this.state.fax1Form,
                "fax2": this.state.fax2Form,
                "pic_name": this.state.picNameForm,
                "pic_email": this.state.picEmailForm,
                "pic_phone_no": this.state.picPhoneForm,
                "pic_mobile_no": this.state.picMobileForm,
                "status": this.state.statusForm,
            }
            // console.log(data)
            let obj = JSON.stringify(data);    
            const result = await axios.put(`${apiUrl}/edit/${idData}`, obj, BASE_HEADER)
                                .then(res => res)
                                .catch((error) => error.response )
            if(result.data.status == true){
                
                NotificationManager.success("Success update "+masterTitleLower+" data", 'Success message') 
                
                this.setState({ openDialog: false });
                this.props.closeDialog(result.data);  
            }else{
                NotificationManager.error("Failed update "+masterTitleLower+" data : "+result.data.message, 'Error message')
                
            }
        }
        
    };


    //logic open edit ===========================================================================
    handleClickOpenEdit = async(id) => {
        this.setState({openDialog: true, idData:id})

        const result = await axios.get(`${apiUrl}/${id}`, BASE_HEADER)
                            .then(res => res)
                            .catch((error) => error.response )
        // console.log(result)
        if(result.data.status == true){
         
            this.setState({
                nameForm:result.data.data.name,
                codeForm:result.data.data.code,
                businessTypeForm:result.data.data.business_type,
                cityForm:result.data.data.city,
                countryForm:result.data.data.country,
                addressForm:result.data.data.address,
                zipCodeForm:result.data.data.zip_code,
                stateForm:result.data.data.state,
                phone1From:result.data.data.phone1,
                phone2Form:result.data.data.phone2,
                fax1Form:result.data.data.fax1,
                fax2Form:result.data.data.fax2,
                picNameForm:result.data.data.pic_name,
                picEmailForm:result.data.data.pic_email,
                picPhoneForm:result.data.data.pic_phone_no,
                picMobileForm:result.data.data.pic_mobile_no,
                statusForm:result.data.data.status,

            })      
        }
                         
    };

    // end function sales =================================================================
    
    render() {
        const {classes} = this.props

        return (
            <div>
                <Snackbar
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  open={this.state.openSnackSuccess}
                  autoHideDuration={4000}
                  onClose={()=> this.setState({ openSnackSuccess: false })}
                >
                  <MySnackbarContentWrapper
                    onClose={()=> this.setState({ openSnackSuccess: false })}
                    variant="success"
                    message={this.state.messageSnackBar}
                  />
                </Snackbar>
                <Snackbar
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  open={this.state.openSnackErr}
                  autoHideDuration={4000}
                  onClose={()=> this.setState({ openSnackErr: false })}
                >
                  <MySnackbarContentWrapper
                  onClose={()=> this.setState({ openSnackErr: false })}
                    variant="error"
                    message={this.state.messageSnackBar}
                  />
                </Snackbar>

                <NotificationContainer/>
                    
                <Dialog
                fullScreen
                open={this.state.openDialog}
                onClose={() => this.handleClose('batal')}
                TransitionComponent={Transition}
                >
                <AppBar className="sticky-container">
                    <Toolbar>
                    <Typography variant="h6" color="inherit" className={classes.flex}>
                        {masterTitleCapital}
                    </Typography>
                    <Button variant="raised" className="bg-white text-black" onClick={() => this.handleClose('batal')}>
                        batal
                    </Button>&nbsp;&nbsp;
                    <Button variant="raised" color="primary" onClick={() => this.handleClose(this.state.action)}>
                        {this.state.action}
                    </Button>
                    </Toolbar>
                </AppBar>
                <br/>
                <br/>
                <div className="app-wrapper">
                    <Grid container spacing={24}>
                        <Grid item xs={6}>
                                <TextField
                                  label="Nama"
                                  value={this.state.nameForm}
                                  fullWidth
                                  onChange={(e) => this.setState({nameForm: e.target.value})}
                                />
                                <TextField
                                  label="Code"
                                  value={this.state.codeForm}
                                  fullWidth
                                  onChange={(e) => this.setState({codeForm: e.target.value})}
                                />

                                <InputVirtual 
                                    label="Business Type"
                                    value=""
                                    name="name"
                                    lengthData={20}
                                    url={BASE_URL_APIv5+"/business-type/search"}
                                    getData={this.callbackBusiness}
                                    setData={[{name:"id",value:this.state.businessTypeForm.toString(),"logic_operator":"=","operator":"AND"}]}
                                    fullWidth={true}
                                    dialogForm="DialogFormBusinessType"
                                />

                                <TextField
                                  label="City"
                                  value={this.state.cityForm}
                                  fullWidth
                                  onChange={(e) => this.setState({cityForm: e.target.value})}
                                />

                                <TextField
                                  label="Country"
                                  value={this.state.countryForm}
                                  fullWidth
                                  onChange={(e) => this.setState({countryForm: e.target.value})}
                                />
                            
                                <TextField
                                  label="Address"
                                  value={this.state.addressForm}
                                  multiline
                                  fullWidth
                                  onChange={(e) => this.setState({addressForm: e.target.value})}
                                />
                            
                                <TextField
                                  label="Zip Code"
                                  value={this.state.zipCodeForm}
                                  fullWidth
                                  onChange={(e) => this.setState({zipCodeForm: e.target.value})}
                                />
                            
                                <TextField
                                  label="State"
                                  value={this.state.stateForm}
                                  fullWidth
                                  onChange={(e) => this.setState({stateForm: e.target.value})}
                                />
                            
                        </Grid>

                        <Grid item xs={6}>
                            
                                {/* <DatePicker
                                    style={{marginTop:16}}
                                    fullWidth
                                    clearable
                                    label="Birth Date"
                                    value={this.state.birthDateForm}
                                    format="MMMM Do YYYY"
                                    onChange={(date) => this.setState({birthDateForm: date})}
                                    animateYearScrolling={false}
                                    leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                                    rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                                /> */}
                                
                            
                                <TextField
                                  label="Phone  1"
                                  value={this.state.phone1From}
                                  fullWidth
                                  onChange={(e) => this.setState({phone1From: e.target.value})}
                                />
                            
                                <TextField
                                  label="Phone 2"
                                  value={this.state.phone2Form}
                                  fullWidth
                                  onChange={(e) => this.setState({phone2Form: e.target.value})}
                                />
                            
                                <TextField
                                  label="Fax 1"
                                  value={this.state.fax1Form}
                                  fullWidth
                                  onChange={(e) => this.setState({fax1Form: e.target.value})}
                                />

                                <TextField
                                  label="Fax 2"
                                  value={this.state.fax2Form}
                                  fullWidth
                                  onChange={(e) => this.setState({fax2Form: e.target.value})}
                                />  

                                <TextField
                                  label="Pic Name"
                                  value={this.state.picNameForm}
                                  fullWidth
                                  onChange={(e) => this.setState({picNameForm: e.target.value})}
                                />

                                <TextField
                                  label="Pic Email"
                                  value={this.state.picEmailForm}
                                  fullWidth
                                  onChange={(e) => this.setState({picEmailForm: e.target.value})}
                                />

                                <TextField
                                  label="Pic Phone No"
                                  value={this.state.picPhoneForm}
                                  fullWidth
                                  onChange={(e) => this.setState({picPhoneForm: e.target.value})}
                                />

                                <TextField
                                  label="Pic Mobile No"
                                  value={this.state.picMobileForm}
                                  fullWidth
                                  onChange={(e) => this.setState({picMobileForm: e.target.value})}
                                />
                            
                                <FormControlLabel
                                        value="left"
                                        control={
                                            <Switch
                                            checked={this.state.statusForm}
                                            onChange={(e) => this.setState({statusForm: e.target.checked})}
                                            value="isActive"
                                            color="primary"
                                            />
                                        }
                                        label="Status"
                                />
                            
                        </Grid>
                        
                    </Grid>
                </div>
                </Dialog>
                
                    
               
            </div>
        );
    }
}

export default withStyles(styles)(DialogForm);


// WEBPACK FOOTER //
// ./app/routes/MasterCompany/DialogForm.js